import React, {useState, useEffect } from 'react'
import { connect } from 'react-redux'
import ReactHtmlParser from 'react-html-parser';
import { InHomeUtils } from './../../../util/inhomeUtils';
import {getPerkActualPrice } from './../../midnight/services/dataFormatter';
import { orderConstants } from './../../orderSummary/orderSummaryConstants';
import * as cartActions from './../../../action/cart'
import { TextLink } from '@vds/buttons';
import { Body, Micro, Title } from '@vds/typography';
import { ListGroup, ListGroupItem, ListGroupItemImage, ListGroupItemTitle } from '@vds/lists';
import constants from '../../midnight/perks/constants';

const ReviewOrderReskin = (props) => {
    const { lqState, cartRedState,cartProfileState, saveState, buildProductState, visitId, dispatch, linkEditTagCall, showMovesOldCart, moveExpState, appState,flowType, movesCustOpt} = props;
    
    const cartState = showMovesOldCart ? cartRedState: cartProfileState;
    let movesEligibility = "";
    if(InHomeUtils.isNotEmpty(moveExpState) && InHomeUtils.isNotEmpty(moveExpState.movesEligibility)){
      movesEligibility = moveExpState?.movesEligibility==="NONSEAMLESS" || movesCustOpt==="NONSEAMLESS" ? 'NONSEAMLESS' :'SEAMLESS';     
    }

    const hasYoutubePerkDiscount = cartState?.cartData?.[Number.isInteger(splitBillTab) ? splitBillTab : 0]?.Promotions?.promotions?.find?.(p => p?.offerAttrValue === "YOUTUBEPREMIUM_PERK_DISCOUNT");
    const isMobile = (window.screen.width < 768) ? true : false;  
    const [splitBillTab, setactiveTabIndex] = useState(0);
    const isMM4Qualified = cartState?.cartData[splitBillTab]?.serviceHeaders?.servicehead?.find((item) => item?.prodType ==='FTTPD' && item?.keyword?.includes('MM4'))  
    const [ isClassicalFlow ] = useState(movesEligibility === "SEAMLESS" ? ( !isMM4Qualified && !buildProductState.internet.mm3Qualified):!buildProductState.mnFromApi);   
    let isAutopayinCart = false; 
    let removedPerks = ''
    let perksData="";
    let internetEquipment = '';
    let internetServiceHeader = '';
    let internetPrice = 0;
    let internetSecTotalPrice = 0;
    let tvServiceHeader = '';
    let tvEquipment = '';
    let tvPrice = 0;
    let tvSecTotalPrice = 0;
    let voiceServiceHeader = '';
    let voiceEquipment = '';
    let voicePrice = 0;
    let voiceSecTotalPrice = 0;
    let numText = 'New Phone Number';
    let displayTN = `(${buildProductState.requestTN.slice(0, 3)}) ${buildProductState.requestTN.slice(
      3,
      6,
    )} -${buildProductState.requestTN.slice(6, 10)}`;
    let isCartDataEmpty = cartState.cartData !== null && cartState.cartData.length !== 0 ? true : false;
    let classicalTitle = isCartDataEmpty && cartState.cartData[splitBillTab].serviceHeaders!==null ? cartState.cartData[splitBillTab].serviceHeaders.title :'';
    let classicalPrice = isCartDataEmpty && cartState?.cartHeader[splitBillTab]?.serviceHeaders!==null ? cartState?.cartData[splitBillTab]?.serviceHeaders?.totalPrice:'';
    let classicDoublePlay = classicalTitle?.toLowerCase()?.includes('verizon double play');
    let classicTriplePlay = classicalTitle?.toLowerCase()?.includes('verizon triple play');
    if(classicDoublePlay || classicTriplePlay){
      classicalPrice = isCartDataEmpty && cartState?.cartHeader[splitBillTab]?.monthlyRcPrice!==null ? cartState?.cartHeader[splitBillTab]?.monthlyRcPrice:'';
    }
    const isStreamServiceSelected = cartState.cartData[splitBillTab]?.streamService?.streamServiceProds?.length > 0    
    
    const isInternetSelected = (buildProductState?.internet?.selectedProduct !== null  || cartState?.cartOrderDetail?.servicesOrdered?.indexOf("DATA") > -1 );
    const isTVSelected = (buildProductState?.tv?.selectedProduct !== null ||  cartState?.cartOrderDetail?.servicesOrdered?.indexOf("VIDEO") > -1 || isStreamServiceSelected);
    const isVoiceSelected = (buildProductState?.voice?.selectedProduct !== null  ||  cartState?.cartOrderDetail?.servicesOrdered?.indexOf("FIOS_VOICE") > -1);
    {/** Classic Address year agreement */}
    let yearAgreement = '';
    if (isClassicalFlow &&
      isCartDataEmpty &&
      cartState.cartData[splitBillTab].serviceHeaders !== undefined &&
      cartState.cartData[splitBillTab].serviceHeaders.servicehead !== undefined &&
      cartState.cartData[splitBillTab].serviceHeaders.servicehead !== null &&
      cartState.cartData[splitBillTab].serviceHeaders.servicehead.length > 0
    ) {
      yearAgreement = cartState.cartData[splitBillTab].serviceHeaders.servicehead       
      .map((head, index) => {
        if (head.prodName.indexOf('year') > -1) {            
          
          return <li key={index}  style={{margin:"16px 0px 20px 0px"}}>
            <div className={ "margin-bottom-zero cartSubhead"} style={{margin:"16px 0px 20px 0px"}}>
              <Body>
                <div>
                  <span className="setupwaived tiny-p-70 medium-p-75"><Body size= {isMobile ? "small" : 'medium'}>{head.prodName}</Body>
                  </span>
                  <span className={ "text-right includedRight right tiny-p-30 medium-p-25 totalDiscount-color" }></span>
                </div>
              </Body>
            </div>
            </li>
        }
         return '';
        
      });
       
    }   

  const checkAPInternetDiscountIncart = () => {
    let autoPayinCart = false;
    if (
      cartState?.cartData[cartState?.splitBillTab]?.Promotions?.promotions?.length > 0
    ) {
      cartState?.cartData[
        cartState?.splitBillTab
      ]?.Promotions?.promotions?.map(function (product) {
        // if (
        //   InHomeUtils.isNotNull(product) &&
        //   InHomeUtils.isNotNull(product?.promoId) &&
        //   (product?.promoId === "Q7734")
        // ) {
        //   autoPayinCart = true;
        // }
        if (InHomeUtils.isNotNull(product)  && InHomeUtils.isNotNull(product?.offerAttrValue) && (product?.offerAttrValue==="FCP_AUTOPAY_DISCOUNT" || product?.offerAttrValue?.includes?.("$10_AutoPay") || product?.offerAttrValue?.includes?.("$5_AutoPay")) && !product?.offerAttrValue?.toUpperCase?.()?.includes?.("DECLINE")) {
          autoPayinCart = true;
        }
      });
    }
    return autoPayinCart;
  };

  const checkAPTVDiscountIncart = () => {
    let autoPayinCart = false;
    if (
      cartState?.cartData[cartState?.splitBillTab]?.Promotions?.promotions
        ?.length > 0
    ) {
      cartState?.cartData[
        cartState?.splitBillTab
      ]?.Promotions?.promotions?.map(function (product) {
        if (InHomeUtils.isNotNull(product)  && InHomeUtils.isNotNull(product?.offerAttrValue) && (product?.offerAttrValue==="FCP_AUTOPAY_DISCOUNT" || product?.offerAttrValue?.includes?.("$10_AutoPay") || product?.offerAttrValue?.includes?.("$5_AutoPay")) && !product?.offerAttrValue?.toUpperCase?.()?.includes?.("DECLINE")) {
          autoPayinCart = true;
        }
      });
    }
    return autoPayinCart;
  };

    const getInternetServiceHeader = () => {
      let title = '';
      let internetToggleEnabled = checkAPInternetDiscountIncart() || buildProductState?.internet?.mnhSignupIndicator === "Y";
      internetServiceHeader = cartState.cartData[splitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
        if (
          isCartDataEmpty &&         
          serviceheaditems.prodType === 'FTTPD'
        ) {
          title = ReactHtmlParser(serviceheaditems.prodName.substring(serviceheaditems.prodName.indexOf(':') + 1));
          internetPrice = serviceheaditems.price !== '$0.00' || (serviceheaditems.prodType === 'FTTPD' && serviceheaditems.price !== '$0.00') ? serviceheaditems.price + '/mo' : '';
          internetSecTotalPrice= internetSecTotalPrice + (parseFloat(serviceheaditems?.price?.replace("$","")) || 0);
          return true;
        }
      });
      let internetImage ="https://ss7.vzw.com/is/image/VerizonWireless/fios-cr1000b-m-07122024?$pngalpha$&scl=1";
      
      const classicdoubleplay = (isClassicalFlow || (classicDoublePlay || classicTriplePlay));     
      let withDiscount = classicdoubleplay ?'':'With discount';

      return (
        <>
        <div className="margin-bottom-zero">
          {' '}
          <div className="reviewOrderPlantextMini">
            <Body size='small' bold='true' color='#6E6B65'>Internet plan</Body>
          </div>
          <div style={{display:'inline-flex', width:'100%'}}>
            {isMobile && !classicdoubleplay && <>
              <img src={internetImage} className="imgStylingMini" alt="" tabIndex='0' ></img>
              {/* <ListGroupItemImage alt="Internet Image" src={internetImage} size='72'/> */}
            </>}
            <div style={{width:'100%', paddingTop:'8px', paddingBottom:'8px'}}>
              <div className="planHeader reviewOrderEDSFont reviewOrder_inline tiny-p-60 medium-p-75"><Title size="small" primitive='h3'>{title}</Title></div>
              <div className="tiny-p-40 medium-p-25 text-right right">
              <div>
                <Title size="small" primitive='h3'>{internetPrice}</Title></div>
              <div className = { internetToggleEnabled ? '' : 'hide' } >
                {isMobile ? <Micro color="#6F7171">{withDiscount}</Micro>
                : <Body size="small" color="#6F7171">{withDiscount}</Body>}
              </div>
              </div>
            </div>
          </div>
        </div>
        </>
      );
    }
    
    const getInternetSubList = () => {
      let internetEquipmentArray = [];

        {/**Equipments Data */}

        internetEquipmentArray = cartState?.cartData[splitBillTab]?.equipments?.equipment?.filter(
          (equipmentitems) =>
            equipmentitems.prodType !== 'VROOM' &&
            equipmentitems.prodType !== 'DUMMYVROOM' &&
            equipmentitems.prodType !== 'CEDEVICEAPP' &&
            equipmentitems.prodType !== 'CEDEVICEAPPBNDL' &&
            equipmentitems.prodType !== 'VFEATURE' &&
            equipmentitems.prodType !== 'VCPEVMS' &&
            equipmentitems.prodType !== 'VCPEATV' &&
            equipmentitems.prodType !== 'VCPEIP'
        );
        
        internetEquipment = internetEquipmentArray?.map((equipmentitems, index) => {

          let dataPrice = "Included";
          let priceClass = 'totalDiscount-color';
          if(equipmentitems.price!=="Included" &&  (equipmentitems.prodType === 'ROUTERBILLER' || equipmentitems.prodType === "ACCESSPOINTBILLER")){
            dataPrice = parseFloat(equipmentitems?.price?.replace("$","")) || 0;
            internetSecTotalPrice= internetSecTotalPrice + (parseFloat(dataPrice) || 0 );
            dataPrice = `${equipmentitems?.price}/mo`;
            priceClass = '';
          }
          
          return <li key={index}  style={{margin:"6px 0px 20px 0px"}}>
            <div className={ "margin-bottom-zero cartSubhead"} style={{margin:"16px 0px 20px 0px"}}>
              <div className="setupwaived internetEquipmentPlan">
                <Body size={isMobile ? "small" : "medium"} color="#000000">
                  {equipmentitems.prodTypeVal === 'CUSTOMER_PROVIDED_ROUTER' &&
                  buildProductState !== undefined &&
                  buildProductState.customRouterName !== undefined &&
                  buildProductState.customRouterName !== ''
                  ? ReactHtmlParser(buildProductState.customRouterName)
                  : InHomeUtils.isNotNull(equipmentitems.quantity) && equipmentitems.quantity > 1
                  ? ReactHtmlParser(equipmentitems.prodName) + '(' + equipmentitems.quantity + ' )'
                  : equipmentitems.prodId === 'Q7757'
                  ? (equipmentitems.prodName = 'Fios Extender')
                  : ReactHtmlParser(equipmentitems.prodName?.trim() === 'Rent: Verizon Router' ? 'Router only' : equipmentitems.prodName)}
                </Body>
              </div>
              <span className={ `text-right includedRight right tiny-p-30 medium-p-25 ${priceClass}` }>{dataPrice}</span>
            </div>
          </li>
        });

      {/******** Rewards Offers section */}     
      
      let internetRewardOffers = '';
      let isnetflixPerkRewardOffer = false;
      if (
        isCartDataEmpty &&
        cartState.cartData[splitBillTab].rewardOffers !== undefined &&
        cartState.cartData[splitBillTab].rewardOffers.rewardOffers !== undefined &&
        cartState.cartData[splitBillTab].rewardOffers.rewardOffers !== null &&
        cartState?.cartData?.[splitBillTab]?.rewardOffers?.rewardOffers?.length > 0
      ) {
        const saveTheSaleOffers = ['R3883','R3884','R3885'];
        internetRewardOffers = cartState?.cartData?.[splitBillTab]?.rewardOffers?.rewardOffers?.filter((rewardItems) => rewardItems?.offerFor === 'DATA' && rewardItems?.offerFor !== 'SPCLDISCOUNT' && rewardItems?.offerAttrValue !== "MF4MRKF15" && rewardItems?.offerAttrValue !== "MF4DISCF15")
        ?.map((reward, index) => { 
        // .filter((rewardItems) => rewardItems.offerFor === 'DATA' && rewardItems?.offerAttrValue !== 'NETMAX_PERK_DISCOUNT')  // ITT-695795 due to this issue commented
          if(reward.offerFor === 'DATA' && reward?.offerAttrValue === 'NETMAX_PERK_DISCOUNT')
          {
            isnetflixPerkRewardOffer = true;
          }

          if(reward.offerFor === 'DATA' && reward?.offerAttr === 'PRICELOCK')
          {
            yearAgreement = "reward";
          }
         
          const starzRewardOffer= <span style={{color:'#6F7171',fontSize:"14px"}}>$10.99/mo after</span>
          let promoTxt = reward?.promoText;
          if(saveTheSaleOffers?.includes(reward?.promoId))
          {
             if(reward?.promoId ==="R3883"){
              promoTxt = "$200 Verizon Gift Card";
             }
             if(reward?.promoId ==="R3884"){
              promoTxt = "$100 Verizon Gift Card";
             }
             if(reward?.promoId ==="R3885"){
              promoTxt = "$50 Verizon Gift Card";
             }
             
          }
          
           if(reward?.promoId ==="R4049"){
            promoTxt = reward?.promoText?.replace('Fios','Xbox');
            if (promoTxt?.includes("Xbox Gaming Bundle")) {
              promoTxt = "Xbox Headset + Controller";
            }
           }
           if(reward?.promoId ==="R4140"){
            promoTxt = reward?.promoText?.replace('Fios','Xbox');
            if (promoTxt?.includes("Xbox Gaming Bundle")) {
              promoTxt = "Xbox Bundle - Headset + Controller";
            }
           }

           if(reward?.promoId ==="R4139"){
            if (promoTxt?.includes("series") || promoTxt?.includes("Series") ) {
              promoTxt = "Xbox Series S";
            }
           }

           if(reward?.promoId ==="R4050" || reward?.promoId ==="R4141"){
            if (promoTxt?.includes("$50 Xbox eGift Card")) {
              promoTxt = "Xbox $50 Gift Card";
            }
           }

           if(reward?.promoId === 'R4570'){
            promoTxt = promoTxt?.replace('on us','');
          }
          
          return <li key={index}  style={{margin:"16px 0px 20px 0px"}}>
            <div style={{alignContent: 'flex-end'}}>
            <div className={ "margin-bottom-zero cartSubhead"} style={{margin:"16px 0px 20px 0px"}}>
              <div className="setupwaived tiny-p-70">
                <Body size={isMobile ? "small" : "medium"} color="#000000">{promoTxt}</Body>
              </div>
              <span className={ "text-right includedRight right tiny-p-30 medium-p-25 totalDiscount-color" }>{reward?.promoId ==="R4339" ? <span style={{color:'black'}}>$0/mo {starzRewardOffer} </span>: 'Included'}</span>
            </div>
            </div>
          </li>
        });
      }

      {/****Special gift offers */}
      
      let internetSpecialOffer = '';
      if (
        isCartDataEmpty &&
        cartState.cartData[splitBillTab].Promotions !== undefined &&
        cartState.cartData[splitBillTab].Promotions.promotions !== undefined &&
        cartState.cartData[splitBillTab].Promotions.promotions !== null &&
        cartState.cartData[splitBillTab].Promotions.promotions.length > 0
      ) {
        internetSpecialOffer = cartState.cartData[splitBillTab].Promotions.promotions
        .filter((promoItems) => promoItems?.offerFor === 'DATA' &&  (promoItems?.offerAttrValue === 'NETMAX_PERK_MARKER' && promoItems?.promoId === 'R4262') && promoItems?.offerAttr !=='PRICING' && promoItems?.offerAttr !== 'JMPADD' && promoItems?.offerAttr !=='EQUIPMENT' && promoItems?.offerAttrValue !== 'DISNEY_BUNDLE_PERK_TRACKER' && promoItems?.offerAttrValue !== 'DISNEY_BUNDLE_PERK_MARKER' && ((promoItems?.offerAttr !== 'SPCLDISCOUNT' && !isClassicalFlow) || (isClassicalFlow && promoItems?.offerAttr === 'SPCLDISCOUNT' && !(promoItems?.offerAttrValue?.toLowerCase?.()?.indexOf?.('autopay') !== -1 || promoItems?.offerAttrValue?.toLowerCase?.()?.indexOf?.('auto pay') !== -1) && promoItems?.offerAttrValue?.toLowerCase?.()?.indexOf?.('decline') === -1 ) || (isClassicalFlow && promoItems?.offerAttrValue !== 'DISNEY_BUNDLE_PERK_DISCOUNT')) || (promoItems?.offerAttrValue?.toUpperCase?.() === 'FIOS_LOCALJBLCLIP5_Q225_PROMO' || promoItems?.offerAttrValue?.toUpperCase?.() === 'FIOS_LOCALJBLPARTYBOX_Q225_PROMO' || promoItems?.offerAttrValue?.toUpperCase?.() === 'FIOS_RAYBAN_META_GLASSES' ||  promoItems?.offerAttrValue?.toUpperCase?.() === 'FIOS_SAMSUNGTECHCREDITONUS_BESTBUY')) 
        .map((promo, index) => {
          // if((promo.offerAttr === 'SPCLDISCOUNT' && !isClassicalFlow) || (isClassicalFlow && promo.offerAttr === 'SPCLDISCOUNT' && (promo.offerAttrValue.toLowerCase().indexOf('autopay') > -1 || promo.offerAttrValue.toLowerCase().indexOf('auto pay') > -1))){
          //   return null;
          // }
          if (promo.offerAttrValue !== '$20_FCPDataNYDMA') {

            
            
            if (promo.promoText !== null && promo.promoText !== undefined && promo.promoText.indexOf('Auto Pay') > -1) {
              isAutopayinCart = true;
            }
            if(promo?.promoId === 'R4262'){
              promo.promoText = "Netflix & Max (With Ads) for 12 months on us"
              //return null;
              if(isnetflixPerkRewardOffer){
                return null;
              }
            }
            
            return <li key={index}  style={{margin:"16px 0px 20px 0px"}}>
              <div className={ "margin-bottom-zero cartSubhead"} style={{margin:"16px 0px 20px 0px"}}>
                <div className="setupwaived tiny-p-70">
                  <Body size={isMobile ? "small" : "medium"} color="#000000">{promo.promoText.includes('$')
                    ? promo.promoText
                    : promo.price && promo.price !== '0.00'
                    ? parseFloat(promo.price) === parseInt(promo.price)
                      ? promo.promoText
                      : promo.promoText
                    : promo.promoText}
                  </Body>
                </div>
                <span className={ "text-right includedRight right tiny-p-30 medium-p-25 totalDiscount-color" }>Included</span>
              </div>
            </li>
          }
        });
      }

      if(yearAgreement===''){

        if (
          isCartDataEmpty &&
          cartState.cartData[splitBillTab].Promotions !== undefined &&
          cartState.cartData[splitBillTab].Promotions.promotions !== undefined &&
          cartState.cartData[splitBillTab].Promotions.promotions !== null &&
          cartState.cartData[splitBillTab].Promotions.promotions.length > 0
        ) {
          yearAgreement = cartState.cartData[splitBillTab].Promotions.promotions
          .filter((promoItems) => promoItems.offerFor === 'DATA' &&  (promoItems?.offerAttr === 'PRICELOCK')) 
          .map((promo, index) => {
            return <li key={index}  style={{margin:"16px 0px 20px 0px"}}>
            <div className={ "margin-bottom-zero cartSubhead"} style={{margin:"16px 0px 20px 0px"}}>
              <Body size={isMobile ? "small" : "medium"} color="#000000">
                <div>
                  <span className="setupwaived tiny-p-70 medium-p-75"><Body size= {isMobile ? "small" : 'medium'}>{promo.promoText}</Body>
                  </span> 
                  <span className={ "text-right includedRight right tiny-p-30 medium-p-25 totalDiscount-color" }>Included</span>                 
                </div>
              </Body>
              
            </div>
            </li>

          })
        }

      }

      {/***Perks Data */}
      if (
        isCartDataEmpty &&
        cartState.cartData[splitBillTab].perks !== undefined &&
        cartState.cartData[splitBillTab].perks !== null &&
        cartState.cartData[splitBillTab].perks.perks !== undefined &&
        cartState.cartData[splitBillTab].perks.perks !== null &&
        cartState.cartData[splitBillTab].perks.perks.length > 0
      ) {

        const perks = cartState.cartData[splitBillTab]?.perks?.perks;

        perksData = perks.map((perk, index) => {

          let perkActPrice;

          if(perk?.keyword) {
            const perkMrp = perk?.keyword?.split('MRP:')?.[1];
            perkActPrice = perkMrp?.split('|')?.[0];
          } else {
            perkActPrice = getPerkActualPrice(perk.prodId);
          }

          // const perkSavings = (parseFloat(perkActPrice) - parseFloat(perk?.price?.replace("$", "")?.replace("/mo", "")))?.toFixed(2);
          const perkSavings = perk?.price;
          const perkSavingsPrice = movesCustOpt === "SEAMLESS" ? parseFloat(perkSavings?.replace("$", ""))?.toFixed(2) : (parseFloat(perkActPrice) - parseFloat(perk?.bundleActucalPrice)).toFixed(2);
          const perkPromosAvailable = ((buildProductState?.isNetmaxPromoEligible && perk?.prodId === 'R3559') || (buildProductState?.isDisneyPromoPresent && perk?.prodId === 'R3558') || ((hasYoutubePerkDiscount && perk?.prodId === constants.YOUTUBE_PREMIUM)));
          
          internetSecTotalPrice= internetSecTotalPrice + (parseFloat(perkSavings) || 0 );
          return <li  key={index} id={perk.id} style={{margin:"16px 0px 16px 0px"}}>
            <div className={ "margin-bottom-zero cartSubhead"} style={{margin:"16px 0px 16px 0px"}}>
              <div style={{alignContent: 'flex-end'}}>
                <div className="setupwaived tiny-p-70">
                  <Body size={isMobile ? "small" : "medium"} color="#000000">{perk.prodName}</Body>
                </div>
                <span className={ "reskin-right-text text-right right includedRight tiny-p-30 medium-p-25" }>{perkSavings + '/mo'}{isMobile && !(perkPromosAvailable) &&  <span className={ "perksStrickoutPrice " }>{'was ' + '$' + perkActPrice + '/mo'}</span>}</span>
                { !isMobile && !(perkPromosAvailable) &&<span className={ "perksStrickoutPrice text-right right includedRight tiny-p-30 medium-p-30" }>{'was ' + '$' + perkActPrice + '/mo'}</span>}
              </div>
                  {
                  perkPromosAvailable
                  ? <>
                      <span className="setupwaived tiny-p-60 medium-p-60 cart_perk_offer">
                        {/* Making this change as per ACT112-701 story comments */}
                        {/* Special gift, on us, for 12 months */}
                      </span>
                      <span className={"text-right right tiny-p-40 medium-p-40 cart_perk_offer" }>
                        {(hasYoutubePerkDiscount && perk?.prodId === constants.YOUTUBE_PREMIUM)
                          ? "$10/mo after 6 months"
                          : "$10/mo after 12 months"
                        }
                      </span>
                    </>
                  : <></>
                  }
            </div>
          </li>
        });
      }
        
        const noPerksData = <>
          <div style={{margin:"16px 0px 20px 0px"}}>
            <Body>
              <div className = 'includedRight' style={{padding:"0px 0px 20px 0px"}}>
                <span className="tiny-p-70 medium-p-100">{ReactHtmlParser(orderConstants.noPerksTxt)}</span>
              </div>
            </Body>
            <Body>
              <div>                 
                  <TextLink onClick={togglePerks} className='addPerksbtn' tabIndex="0" role="button" aria-hidden="true">Add perks</TextLink>
                  
              </div>
            </Body>
          </div>
        </>       
        
        return (
          <>
          <div className={internetEquipment?.length ? 'cart-tabs' : 'hide'}>
            <ul className="savingLineItems">{internetEquipment}</ul>
            {yearAgreement?.length > 0 && yearAgreement !=="reward" ?<ul className="savingLineItems">{yearAgreement}</ul> :''}
          </div>
          <div className={internetSpecialOffer?.length || internetRewardOffers?.length ? 'cart-tabs' : 'hide'}>
            <Body size="small" bold="true" color="#6E6B65">Special gifts, on us</Body>
            <ul className="savingLineItems">{internetSpecialOffer}</ul>
            <ul className="savingLineItems">{internetRewardOffers}</ul>            
          </div>
          {/* ITT-699111 Removing classicflow condition and keeping the condition generic to display perks, only when perks is added to cart 
          !isClassicalFlow || (isClassicalFlow && (classicDoublePlay || classicTriplePlay)) */}
          {perksData?.length > 0 && <div className="cart-tabs">
            <Body size="small" bold="true" color="#6E6B65">Perks</Body>
            <ul className="savingLineItems">{perksData}</ul>
          </div>}
          </>
          );
    }
    
    const getTVServiceHeader = () => {

      let tvTitle = '';
      const tvToggleEnabled = checkAPTVDiscountIncart();


      let tvImage ="https://ss7.vzw.com/is/image/VerizonWireless/fios-tvsettopbox-m-07122024?$pngalpha$&scl=1";

      if(isStreamServiceSelected){
        tvImage = "https://ss7.vzw.com/is/image/VerizonWireless/fios-youtube-m-07162024?$pngalpha$&scl=1";

        tvServiceHeader = cartState.cartData[splitBillTab]?.streamService?.streamServiceProds.map((serviceheaditems, index) => {
          if (
            isCartDataEmpty &&
             serviceheaditems.prodType === 'OTTBASIC'
            ) {
              
              tvTitle = ReactHtmlParser(serviceheaditems.prodName);
              tvPrice = serviceheaditems.price !== '$0.00' || (serviceheaditems.prodType === 'OTTBASIC' && serviceheaditems.price !== '$0.00') ? serviceheaditems.price + '/mo' : '';
              tvSecTotalPrice = tvSecTotalPrice + (parseFloat(serviceheaditems?.price?.replace("$","")) || 0);
              return true;
  
            }});  

      }else{

        tvServiceHeader = cartState.cartData[splitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
          if (
            isCartDataEmpty &&
            cartState.cartData[splitBillTab]?.serviceHeaders !== undefined &&
            cartState.cartData[splitBillTab]?.serviceHeaders?.servicehead !== undefined &&
            cartState.cartData[splitBillTab]?.serviceHeaders?.servicehead !== null &&
            cartState.cartData[splitBillTab]?.serviceHeaders?.servicehead?.length > 0 &&
            serviceheaditems?.prodType !== 'FTTPD' &&
            serviceheaditems?.prodType !== 'FVPRIMARY' &&( serviceheaditems?.prodType === 'BASIC' || serviceheaditems?.prodType === 'BASICDIFF')
            ) {
              
              tvTitle = ReactHtmlParser(serviceheaditems.prodName);
              tvPrice = serviceheaditems.price !== '$0.00' || ((serviceheaditems.prodType === 'BASIC'  || serviceheaditems.prodType === 'BASICDIFF') && serviceheaditems.price !== '$0.00') ? serviceheaditems.price + '/mo' : '';
              tvSecTotalPrice = tvSecTotalPrice + (parseFloat(serviceheaditems?.price?.replace("$","")) || 0);
              return true;  
            }}); 
          }

         
          const classicdoubleplay = (isClassicalFlow || (classicDoublePlay || classicTriplePlay));     
          let withDiscount = classicdoubleplay ?'' :'With discount';
          
          return (
            <>
            <div className="margin-bottom-zero">
              {' '}
                  <div className="reviewOrderPlantextMini"><Body size='small' bold='true' color='#6E6B65'>{`${isStreamServiceSelected ? "Streaming device" : "Live TV"} plan`}</Body></div>
              <div style={{display:'inline-flex', width:'100%'}}>
              {isMobile && !classicdoubleplay && <>
                  <img src={tvImage} className="imgStylingMini" alt="Tv Image"></img>
                  {/* <ListGroupItemImage alt="Tv Image" src={tvImage} size='72px'/> */}
                </>}
                <div style={{width:'100%', paddingTop:'8px', paddingBottom:'8px'}}>
                  <div className="planHeader reviewOrderEDSFont reviewOrder_inline tiny-p-40 medium-p-60"><Title size="small">{tvTitle}</Title></div>
                  <div className="tiny-p-60 medium-p-35 text-right right"><div><Title size="small">{tvPrice}</Title></div>
                  <div className = { tvToggleEnabled || (lqState?.runtimeKey?.enhanceYTTV === 'Y' && tvTitle?.[0]?.trim() === 'YouTube TV') ? '' : 'hide' } >
                    {isMobile ? <Micro color="#6F7171">
                      { lqState?.runtimeKey?.enhanceYTTV === 'Y' && tvTitle?.[0]?.trim() === 'YouTube TV' ? '$72.99/mo for 1 year for new subscribers applied after activation' : withDiscount }</Micro>
                    : <Body size="small" color="#6F7171">
                        { lqState?.runtimeKey?.enhanceYTTV === 'Y' && tvTitle?.[0]?.trim() === 'YouTube TV' ? '$72.99/mo for 1 year for new subscribers applied after activation' : withDiscount }</Body>}
                  </div></div>
                  {/* {
                    !tvToggleEnabled && lqState?.runtimeKey?.enhanceYTTV === 'Y' && tvTitle?.[0]?.trim() === 'YouTube TV'
                    ? <Body size="small" className="bold padding-left">
                      <span className="reviewOrderAPTxt">
                        $72.99/mo for 1 year for new subscribers applied after activation
                      </span>
                    </Body>
                    : <></>
                  } */}
                </div>
              </div>
            </div>
            </>
          );
    }

    
  const getDisplayPrice =(price, isMonthly) => {
    let priceStr = "";
    if (typeof price === "number") {
        priceStr = price.toString();
    } else if (typeof price === "string") {
        priceStr = price.replace(/^(\$)/, "").replace(/\,/g, "").replace(/(\/mo)$/, "");
    }
    const numberFormat = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(priceStr);
    if (numberFormat !== "$NaN") {
        if (numberFormat === "$0.00") {
            return "";
        }
        return numberFormat + (isMonthly ? "/mo" : "");
    } else {
        return price;
    }
  }

    const getTVSubList = () => {

      let streamingDeviceSkip = false;
      const selectedTVProd = buildProductState?.tv?.selectedProduct?.id; 
      const tvProdArray = ['R3574', 'R3576', 'Q9854', 'R3572', 'R3577','R4301','R4303','R4299','R4304'];
      if(tvProdArray.includes(selectedTVProd))
      {
        streamingDeviceSkip = true;
      }

      let tvEquipmentArray = [];
      let displayCEAppsBundle = "";
      let displayFiosConnection = "";
     

      {/**Equipments Data */}

      tvEquipmentArray = cartState?.cartData?.[splitBillTab]?.equipments?.equipment?.filter(
          (equipmentitems) =>
          (equipmentitems?.prodType !== 'DUMMYVROOM' &&
          equipmentitems?.prodType !== 'CEDEVICEAPP' &&
          //equipmentitems?.prodType !== 'VROOM' &&
          (isClassicalFlow ? equipmentitems?.prodType === 'VROOM' : equipmentitems?.prodType !== 'VROOM') &&
          //equipmentitems?.prodType !== 'CEDEVICEAPPBNDL' &&
          (equipmentitems?.prodName || '')?.toLowerCase().trim() !== "i don't want to use a streaming device." && // Introduced due to PRODDEF-37256      
          // equipmentitems?.prodType !== 'VCPEVMS' &&
          // equipmentitems?.prodType !== 'VCPEATV' &&
          equipmentitems?.prodType !== 'ROUTERBILLER' && 
          equipmentitems?.prodType !== 'ACCESSPOINTBILLER' && 
          equipmentitems?.prodType !== 'NETWORKEXTENDERMRC') || (((equipmentitems?.prodType ==='ROUTERBILLER'  || equipmentitems?.prodType ==='ACCESSPOINTBILLER') && (!isInternetSelected && isTVSelected))  && ((isClassicalFlow && !classicDoublePlay) || (!isInternetSelected && isTVSelected)) || (isClassicalFlow && equipmentitems?.prodType === "VFEATURE"))

      );

      {/** Fios TV connections */}
      let fiosTVConnectionArr = [];
      if(buildProductState?.showConnectedApps) {
        // equipmentArr = this.props.cart.cartData[splitBillTab].equipments.equipment.filter(equipItem => !['VROOM', 'DUMMYVROOM', 'CEDEVICEAPP', 'CEDEVICEAPPBNDL','NETWORKEXTENDERMRC'  ].includes(equipItem.prodType));
        fiosTVConnectionArr = cartState?.cartData?.[splitBillTab]?.equipments?.equipment?.filter(equipItem => ['VROOM', 'DUMMYVROOM', 'CEDEVICEAPP', 'CEDEVICEAPPBNDL'].includes(equipItem?.prodType));
        if(fiosTVConnectionArr && fiosTVConnectionArr?.length) {
            let stbCount = 0;
            let ceAppCount = 0;
            let selectedstbProd = buildProductState?.tvConnections && buildProductState?.tvConnections?.selectedProduct && (buildProductState?.tvConnections?.selectedProduct?.prodId || buildProductState?.tvConnections?.selectedProduct?.id) && buildProductState?.tvConnections?.equipments && buildProductState?.tvConnections?.equipments?.filter(p => p && (p?.id === buildProductState?.tvConnections?.selectedProduct?.prodId || p?.id === buildProductState?.tvConnections?.selectedProduct?.id));
            let fiosTVConnectionProd = fiosTVConnectionArr?.filter(p => p?.prodType === 'VROOM');
            let stbProd = fiosTVConnectionArr?.filter(p => p?.prodType === 'VROOM');
            let stbProdbox = fiosTVConnectionArr?.filter(p => p?.prodType === 'DUMMYVROOM');
            
            let ceAppsParityProd = fiosTVConnectionArr?.filter(p => p?.prodType === 'CEDEVICEAPP');
            let ceAppsBundleProd = buildProductState?.ceApps?.selectedProduct && fiosTVConnectionArr?.filter(p => p?.prodType === 'CEDEVICEAPPBNDL' && p?.prodTypeVal !== 'DUMMY');
            let ceAppsBundleDeclinedProd = fiosTVConnectionArr?.filter(p => p?.prodType === 'CEDEVICEAPPBNDL' && p?.prodTypeVal === 'DUMMY');
            let isCEBundleProdinCart = fiosTVConnectionArr.some(p => p?.prodType === 'CEDEVICEAPPBNDL');
            ceAppsBundleDeclinedProd = ceAppsBundleDeclinedProd && ceAppsBundleDeclinedProd?.length ? ceAppsBundleDeclinedProd?.[0] : null;
            fiosTVConnectionProd = fiosTVConnectionProd && fiosTVConnectionProd?.length ? fiosTVConnectionProd?.[0] : null;
            stbProd = stbProd && stbProd?.length ? stbProd?.[0] : null;
            ceAppsParityProd = ceAppsParityProd && ceAppsParityProd?.length ? ceAppsParityProd?.[0] : null;
            ceAppsBundleProd = ceAppsBundleProd && ceAppsBundleProd?.length ? ceAppsBundleProd?.[0] : null;
            let settopboxCount = 0;
            if(stbProd) {
                stbCount = selectedstbProd && selectedstbProd?.length && selectedstbProd?.[0]?.unitCount ? parseInt(selectedstbProd?.[0]?.unitCount) : 0;
            }
            if(stbProdbox) {
                settopboxCount = InHomeUtils.isNotNull(stbProdbox) && InHomeUtils.isNotNull(stbProdbox[0]) && stbProdbox[0].unitCount ? parseInt(stbProdbox[0].unitCount) : 0;
                if(stbCount==0){
                stbCount = settopboxCount;
                }
            }
            if(ceAppsParityProd) {
                ceAppCount = buildProductState?.ceApps && buildProductState?.ceApps?.selectedProduct && buildProductState?.ceApps?.selectedProduct?.quantity ? parseInt(buildProductState?.ceApps?.selectedProduct?.quantity) : 0;
            }
            if(fiosTVConnectionProd) {
                let vroomCount = buildProductState?.vRoom && buildProductState?.vRoom?.selectedProduct && buildProductState?.vRoom?.selectedProduct.unitCount ? parseInt(buildProductState?.vRoom?.selectedProduct?.unitCount) : 0;
                
                let tvCount = InHomeUtils.isNotNull(stbProd) && stbProd?.unitCount ?parseInt(stbProd?.unitCount) : 0;
                if(vroomCount==0){
                    vroomCount=tvCount;
                }
                ceAppCount = vroomCount - stbCount;
                
                
                displayFiosConnection = <div id="Month124856110" className="">
                <div className="cartSubhead margin-bottom-zero">
                    <span id="SinglesectionIteamName" className="tiny-p-70 medium-p-75 inline-block">
                    <Body size={isMobile ? "small" : "medium"}>{vroomCount}{` Fios TV Connection${vroomCount > 1 ? 's' : ''}`} </Body>
                    </span>
                    <span id="SinglesectionIteamName" className="tiny-p-70 medium-p-75 inline-block">
                    <Body size={isMobile ? "small" : "medium"}>
                      {(vroomCount === stbCount) || (stbCount && ceAppCount) ? `${(vroomCount === stbCount) || (stbCount && ceAppCount) ? ` ${stbCount && (stbCount > 1 || ceAppCount) ? `${stbCount}` : ''} Set-Top Box${stbCount > 1 ? 'es' : ''}` : ''}${stbCount && ceAppCount ? ',' : ''} ${ceAppCount ? `${ceAppCount} Streaming Device${ceAppCount > 1 ? 's' : ''}` : '' }`: ""}
                      </Body>
                    </span>
                    <span id="SinglesectionPrice" className="reskin-right-text text-right right tiny-p-30 medium-p-25 inline-block"><Body size={isMobile ? 'medium' : 'large'} color={(fiosTVConnectionProd?.price?.toLowerCase() === 'included') ? '#008331' : '#000000'}>{ getDisplayPrice(fiosTVConnectionProd.price, true)}</Body></span>
                </div>
            </div>
            if(ceAppsBundleProd) {
                displayCEAppsBundle = <li id="Month124856110" className="">
                <p className={"cartSubhead margin-bottom-zero" }>
                    <span id="SinglesectionIteamName" className="tiny-p-70 medium-p-75 inline-block">
                        {ReactHtmlParser(ceAppsBundleProd.prodName)}
                    </span>
                    <span id="SinglesectionPrice" className= { "reskin-right-text text-right right tiny-p-30 medium-p-25 inline-block" }>{getDisplayPrice(ceAppsBundleProd.price, true)}</span>
                </p>
            </li>
            }
            }
            
        }
      }


      tvEquipment = tvEquipmentArray?.map((equipmentitems, index) => {
        const equipItemProdName = (equipmentitems?.prodName || '')?.toString().trim() === 'Rent: Verizon Router' ? 'Router Only' : (equipmentitems?.prodName || '');
        let prodName = ReactHtmlParser(equipItemProdName);
        // if(equipmentitems.prodType === 'VROOM'){
        //   prodName = ReactHtmlParser(equipmentitems.prodName + 'Set-TopBox');
        // }

        let streamingDeviceEquipment = '';
        if(equipmentitems.prodType === 'CEDEVICEAPPBNDL' && (streamingDeviceSkip)){
          streamingDeviceEquipment = <div ><Body size="small" color='#6F7171'>{`$${(parseInt(equipmentitems?.bundleActucalPrice))}/mo after 60 days`}</Body></div>
          
        }
        tvSecTotalPrice = tvSecTotalPrice + (parseFloat(equipmentitems?.price?.replace("$","")) || 0)

        let monthTxt = '/mo';
        // if(((isClassicalFlow && !classicDoublePlay) || (!isInternetSelected && isTVSelected))){
        //   monthTxt = '';
        // }
        if(equipmentitems?.prodType ==='ROUTERNRCBILLER' &&  equipmentitems?.prodTypeVal === 'FTTP_ROUTER_CHR_WIRELESS_CONSUMER' ){
          return
        }
        
        return <div style={{marginBottom: (isMobile ? "8px" : streamingDeviceEquipment ?  "44px" : "16px"), marginTop:"16px"}}>
          <div className="setupwaived tiny-p-50">
            <Body size={isMobile ? "small" : "medium"}>
              {equipmentitems.prodTypeVal === 'CUSTOMER_PROVIDED_ROUTER' &&
              buildProductState !== undefined &&
              buildProductState.customRouterName !== undefined &&
              buildProductState.customRouterName !== ''
              ? ReactHtmlParser(buildProductState.customRouterName)
              : InHomeUtils.isNotNull(equipmentitems.quantity) && equipmentitems.quantity > 1
              ? ReactHtmlParser(prodName) + '(' + equipmentitems.quantity + ' )'
              : equipmentitems.prodId === 'Q7757'
              ? (prodName = 'Fios Extender')
              : ReactHtmlParser(prodName)}
            </Body>
          </div>
          <div className = 'text-right includedRight right tiny-p-25 medium-p-25'>
            <Body size={isMobile ? 'medium' : 'large'} color={(equipmentitems?.price?.toLowerCase() === 'included') ? '#008331' : '#000000'} style={{marginBottom:"16px"}}>
              {(equipmentitems?.price?.toLowerCase() === 'included') ? equipmentitems?.price : equipmentitems?.price + monthTxt }
             {streamingDeviceEquipment}
            </Body>   
        </div>
        </div> 
      });

      
      {/******** Rewards Offers section */}     
      
      let tvRewardOffers = '';
      if (
        isCartDataEmpty &&
        cartState.cartData[splitBillTab].rewardOffers !== undefined &&
        cartState.cartData[splitBillTab].rewardOffers.rewardOffers !== undefined &&
        cartState.cartData[splitBillTab].rewardOffers.rewardOffers !== null &&
        cartState?.cartData?.[splitBillTab]?.rewardOffers?.rewardOffers?.length > 0
      ) {
        tvRewardOffers = cartState.cartData[splitBillTab].rewardOffers.rewardOffers
        .filter((rewardItems) => rewardItems.offerFor === 'VIDEO' && rewardItems.offerAttr === 'VZREWARD')
        .map((reward, index) => {
          if (reward.offerAttrValue !== '$20_FCPDataNYDMA') {

            return <div className={ "margin-bottom-zero"} style={{margin:"16px 0px 20px 0px"}}>
              <div className="setupwaived tiny-p-70">
                <Body size={isMobile ? "small" : "medium"}>
                  {reward.promoText}
                </Body>
              </div>
              <span className={ "text-right includedRight right tiny-p-30 medium-p-25 totalDiscount-color" }>Included</span>
            </div>
            
          }
        });
      }

      {/****Special gift offers****/}
      
      let tvSpecialOffer = '';
      
      if (
        isCartDataEmpty &&
        cartState.cartData[splitBillTab].Promotions !== undefined &&
        cartState.cartData[splitBillTab].Promotions.promotions !== undefined &&
        cartState.cartData[splitBillTab].Promotions.promotions !== null &&
        cartState.cartData[splitBillTab].Promotions.promotions.length > 0 
      ) {        
        
        tvSpecialOffer = cartState.cartData[splitBillTab].Promotions.promotions
        .filter((promoItems) => promoItems.offerFor === 'VIDEO'  && promoItems.offerAttr !=='EQUIPMENT' && ((promoItems.offerAttr !== 'SPCLDISCOUNT' && !isClassicalFlow) || (isClassicalFlow && promoItems.offerAttr === 'SPCLDISCOUNT' && !(promoItems.offerAttrValue.toLowerCase().indexOf('autopay') !== -1 || promoItems.offerAttrValue.toLowerCase().indexOf('auto pay') !== -1) && promoItems?.offerAttrValue?.toLowerCase?.()?.indexOf?.('decline') === -1)))
        .map((promo, index) => {

          // if((promo.offerAttr === 'SPCLDISCOUNT' && !isClassicalFlow) || (isClassicalFlow && promo.offerAttr === 'SPCLDISCOUNT' && (promo.offerAttrValue.toLowerCase().indexOf('autopay') > -1 || promo.offerAttrValue.toLowerCase().indexOf('auto pay') > -1))){
          //   return false;
          // }

          if (promo.promoText !== null && promo.promoText !== undefined && promo.promoText.indexOf('Auto Pay') > -1) {
             isAutopayinCart = true;
          }
                    
          return <div className={ "margin-bottom-zero"} style={{margin:"16px 0px 20px 0px"}}>   
              
            <div className="setupwaived tiny-p-70 medium-p-75 reviewOrderSavings">
            <Body size={isMobile ? "small" : "medium"} color="#000000">{promo.promoText.includes('$')
              ? promo.promoText
              : promo.price && promo.price !== '0.00'
              ? parseFloat(promo.price) === parseInt(promo.price)
                ? promo.promoText
                : promo.promoText
              : promo.promoText}
              </Body>
            </div>
            <span className={ "text-right includedRight right tiny-p-30 medium-p-25 totalDiscount-color" }>Included</span>
          
            
            </div>  
          });
        }  

        {/***fios five selected Channales ***/}
        let fiosFiveSelectedChannels='';
        let fiosFiveSelectedChannelsLayout=''

        if (
          isCartDataEmpty &&
          cartState?.cartData?.[splitBillTab]?.serviceHeaders !== undefined &&
          cartState?.cartData?.[splitBillTab]?.serviceHeaders?.servicehead !== undefined &&
          cartState?.cartData?.[splitBillTab]?.serviceHeaders?.servicehead !== null &&
          cartState?.cartData?.[splitBillTab]?.serviceHeaders?.servicehead?.length > 0 
        ) {
        let fiveChannels = cartState.cartData[splitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {
        if (
          serviceheaditems.prodName.indexOf('Your Fios TV') > -1 ||
          serviceheaditems.prodTypeVal == 'Fios_Five' ||
          serviceheaditems.prodId === 'Q7818'
        ) {
          /**changed the filter from id to prodTypeVal as encountered with grandfathered products with different id */
          cartState?.cartData?.[splitBillTab]?.fiosFiveSelectedChannels?.map((channels, index) => {
            if(channels?.prodName?.toLowerCase().indexOf('additional pack') < 0){
            if (fiosFiveSelectedChannels) {
              fiosFiveSelectedChannels += `, ${ReactHtmlParser(channels?.prodName)}`;
            } else {
              fiosFiveSelectedChannels = ReactHtmlParser(channels?.prodName);
            }
            return true;
          }});
        }})
        if(fiosFiveSelectedChannels){
        fiosFiveSelectedChannelsLayout =<>
            <div className={ "margin-bottom-zero"} style={{margin:"20px 0px 20px 0px"}}>
              <Body>
                <div>
                  <span className="setupwaived tiny-p-70 medium-p-70 reviewOrderSavings">{`Channels - ${ReactHtmlParser(fiosFiveSelectedChannels)} `}</span>
                  <span className={ "text-right includedRight right tiny-p-30 medium-p-25" }><span className={"text-right includedRight  tiny-p-30 medium-p-25 totalDiscount-color" }>Included</span></span>
                </div>
              </Body>
            </div>
          </>
        }
      }

        {/****premium tv channels****/}

        let premiumChannels = '';
        let premiumChannelsPrice = 0;
        let premiumChannelsList = '';
        
        if (
          isCartDataEmpty &&
          cartState.cartData[splitBillTab].channel !== undefined &&
          cartState.cartData[splitBillTab].channel !== null &&
          cartState.cartData[splitBillTab].channel.channelsProds !== undefined &&
          cartState.cartData[splitBillTab].channel.channelsProds !== null &&
          cartState.cartData[splitBillTab].channel.channelsProds.length > 0
        ) {

          premiumChannelsPrice = (cartState?.cartData[splitBillTab]?.channel?.channelsTotalprice || 0);

          cartState.cartData[splitBillTab].channel.channelsProds
          .filter((promoItems) => promoItems.prodType !== "PREMIUMPACK")
          .map((channels, index) => {
              if (premiumChannelsList) {
                premiumChannelsList = `${premiumChannelsList}, ${ReactHtmlParser((channels?.prodName || '').trim())}`;
              } else {
                premiumChannelsList = ReactHtmlParser((channels?.prodName || '').trim());
              }
              return true;
            });
                     
          tvSecTotalPrice = premiumChannelsPrice !== 0 ? tvSecTotalPrice + (parseFloat(premiumChannelsPrice?.replace("$","")) || 0 ) : tvSecTotalPrice;
          premiumChannels = <>
            <div className={ "margin-bottom-zero"} style={{margin:"16px 0px 20px 0px"}}>
              <div className="setupwaived tiny-p-70">
                <Body size={isMobile ? "small" : "medium"} color="#000000">{`Premium channel - ${ReactHtmlParser(premiumChannelsList)}`}</Body>
              </div>
              <span className={ "text-right includedRight right tiny-p-30 medium-p-25" }>{(premiumChannelsPrice === 0 ? `$${premiumChannelsPrice}`: premiumChannelsPrice) + '/mo'}</span>
            </div>
          </>
        }

        let premiumChannelsIncluded = '';       
        let premiumChannelsListIncluded = '';
        
        if (
          isCartDataEmpty &&
          cartState.cartData[splitBillTab].serviceHeaders !== undefined &&
          cartState.cartData[splitBillTab].serviceHeaders.servicehead !== undefined &&
          cartState.cartData[splitBillTab].serviceHeaders.servicehead !== null &&
          cartState.cartData[splitBillTab].serviceHeaders.servicehead.length > 0
        ) {       

          cartState.cartData[splitBillTab].serviceHeaders.servicehead
          .filter((promoItems) => promoItems.prodType === 'PREMIUM')
          .map((channels, index) => {
              if (premiumChannelsListIncluded) {
                premiumChannelsListIncluded = `${premiumChannelsListIncluded}, ${ReactHtmlParser((channels?.prodName || '').trim())}`;
              } else {
                premiumChannelsListIncluded = ReactHtmlParser((channels?.prodName || '').trim());
              }
              return true;
            });

            if(premiumChannelsListIncluded.length > 0){

              premiumChannelsIncluded = <>
                <div className={ "margin-bottom-zero"} style={{margin:"12px 0px 20px 0px"}}>
                  <div className="setupwaived tiny-p-70">
                    <Body size={isMobile ? "small" : "medium"} color="#000000">{ReactHtmlParser(premiumChannelsListIncluded)}</Body>
                  </div>
                  <span className={ "text-right includedRight right tiny-p-30 medium-p-25 totalDiscount-color" }>Included</span>
                </div>
              </>
            }
        }

         {/****international tv channels****/}

        let intrnlChannels = '';
        let intrnlChannelsPrice = 0;
        let intrnlChannelsList = '';

        if (
          isCartDataEmpty &&
          cartState.cartData[splitBillTab].intrnlChannel !== undefined &&
          cartState.cartData[splitBillTab].intrnlChannel !== null &&
          cartState.cartData[splitBillTab].intrnlChannel.intrnlChannelsProds !== undefined &&
          cartState.cartData[splitBillTab].intrnlChannel.intrnlChannelsProds !== null &&
          cartState.cartData[splitBillTab].intrnlChannel.intrnlChannelsProds.length > 0
        ) {

          intrnlChannelsPrice = cartState.cartData[splitBillTab]?.intrnlChannel?.intrnlChannelsProds?.reduce((sum,item)=> sum + parseFloat(item.bundleActucalPrice),0);

          cartState.cartData[splitBillTab].intrnlChannel.intrnlChannelsProds
          .filter((promoItems) => promoItems.prodType !== "INTLPRMSPANISHTIER")
          .map((channels, index) => {
              if (intrnlChannelsList) {
                intrnlChannelsList = `${intrnlChannelsList}, ${ReactHtmlParser((channels?.prodName || '').trim())}`;
              } else {
                intrnlChannelsList = ReactHtmlParser((channels?.prodName || '').trim());
              }
              return true;
            });

          tvSecTotalPrice = tvSecTotalPrice + (parseFloat(intrnlChannelsPrice) || 0 )
          intrnlChannels = <>
            <div className={ ""} style={{margin:"16px 0px 0px 0px"}}>
              <div className="setupwaived tiny-p-70">
                <Body size={isMobile ? "small" : "medium"}>{`International channel - ${ReactHtmlParser(intrnlChannelsList)}`}</Body>
              </div>
              <span className={ "text-right includedRight right tiny-p-30 medium-p-25" }>{'$' + intrnlChannelsPrice + '/mo'}</span>
            </div>
          </>
         }

        return (
          <>
            <div className={displayFiosConnection || tvEquipment?.length || fiosFiveSelectedChannelsLayout?.length ||  premiumChannelsList || intrnlChannelsList || premiumChannelsListIncluded ? 'cart-tabs' : 'hide'}>
                <div>{displayFiosConnection}</div>       
                <div>{tvEquipment}</div>   
                {/* <div>{yearAgreement?.length > 0 ?<ul className="savingLineItems">{yearAgreement}</ul> :''}</div> */}
                <div>{fiosFiveSelectedChannelsLayout}</div>
                <div>{premiumChannels}</div>
                <div>{premiumChannelsIncluded}</div> 
                <div>{intrnlChannels}</div>
                              
            </div>
            <div style={{paddingTop:"16px"}} className={tvSpecialOffer?.length || tvRewardOffers.length ? 'cart-tabs' : 'hide'}>
              <Body size="small" bold="true" color="#6E6B65">Special gifts, on us</Body>               
                <div>{tvSpecialOffer}</div> 
                <div>{tvRewardOffers}</div>
            </div>
        </>
        );
    }

    const getVoiceServiceHeader = () => {
      
      let voiceTitle = '';
      
      voiceServiceHeader = cartState.cartData[splitBillTab]?.serviceHeaders?.servicehead.map((serviceheaditems, index) => {

        if ( serviceheaditems.prodType === 'FVPRIMARY' ) {
            
            voiceTitle = ReactHtmlParser(serviceheaditems.prodName);
            voicePrice = serviceheaditems.price !== '$0.00' || (serviceheaditems.prodType === 'FTTPD' && serviceheaditems.price === '$0.00') ? serviceheaditems.price + '/mo' : '';
            voiceSecTotalPrice = voiceSecTotalPrice + ( parseFloat(serviceheaditems?.price?.replace("$","")) || 0)
            return true;
        
        }});
        
        return (
          <>
            <div className="margin-bottom-zero">
              {' '}
              <div className="reviewOrderPlantextMini"><Body size='small' bold='true' color='#6E6B65'>Phone plan</Body></div>
              <div className="planHeader reviewOrderEDSFont reviewOrder_inline"><Title size="small">{voiceTitle}</Title></div>
              <div className="tiny-p-25 medium-p-25 text-right right"><Title size="small">{voicePrice}</Title></div>
            </div>
          </>
        );
    }

    const getVoiceSubList = () => {
      
      let displayNewNum = '';
      let internationalCalling = '';

        {/**Equipments Data */}
        
        if (buildProductState.hasOwnTn.isPorted && buildProductState.hasOwnTn.portedTn !== '') {
          numText = 'Existing Phone Number';
          displayTN = `(${buildProductState.hasOwnTn.ph1}) ${buildProductState.hasOwnTn.ph2} -${buildProductState.hasOwnTn.ph3}`;
        } else if (
          buildProductState.winback.selectedProduct !== null &&
          buildProductState.winback.selectedProduct.id === 'WINBACKYES' &&
          saveState.resumeIsWinback &&
          saveState.resumeWinbackTN !== null
        ) {
          numText = 'Existing Phone Number';
          displayTN = `(${saveState.resumeWinbackTN.slice(0, 3)}) ${saveState.resumeWinbackTN.slice(
            3,
            6,
          )} -${saveState.resumeWinbackTN.slice(6, 10)}`;
        }
      let requestTN;
      if (movesCustOpt === "SEAMLESS" && moveExpState != undefined && moveExpState != null && moveExpState != "" &&
        moveExpState?.tnText != undefined && moveExpState?.tnText != null &&
        moveExpState?.tnText != "") {
        numText = moveExpState?.tnText;
        requestTN = moveExpState?.tn;
        displayTN = `(${requestTN?.slice(0, 3)}) ${requestTN?.slice(3, 6)} -${requestTN?.slice(6, 10)}`
      }
      if (movesCustOpt === "SEAMLESS" && displayTN?.length < 10 && cartProfileState?.cartOrderDetail?.servicesOrdered?.indexOf("FIOS_VOICE") > -1) {
        const isVoicePresent = cartProfileState?.cartData[splitBillTab]?.serviceHeaders?.servicehead?.find(item => item?.prodType === "FVPRIMARY")
        if (isVoicePresent && isVoicePresent?.prodName?.length > 20 && isVoicePresent?.prodName?.indexOf("(") > -1 && isVoicePresent?.prodName?.indexOf(")") > -1) {
          const phoneNumber = isVoicePresent?.prodName?.slice(isVoicePresent?.prodName?.indexOf("("))
          if (phoneNumber && phoneNumber?.length > 13) {
            requestTN = phoneNumber;
            displayTN = `(${requestTN?.slice(1, 4)}) ${requestTN?.slice(5, 8)} -${requestTN?.slice(9, 13)}`
          }
        }
      } 

        if ((displayTN !== '' && buildProductState.winback?.selectedProduct?.name?.includes('new phone number')) ||(movesCustOpt === "SEAMLESS" && displayTN?.length > 10)) {
          displayNewNum = <>
            <div className={ "margin-bottom-zero"} style={{margin:"16px 0px 20px 0px"}}>
              <div id="winpack" className="setupwaived tiny-p-70">
                <Body size={isMobile ? "small" : "medium"}>{numText + ' : ' + displayTN}</Body>
              </div>
              <span className={ "text-right includedRight right tiny-p-30 medium-p-25 totalDiscount-color" }>Included</span>
            </div>
          </>
        }
        
        //Commenting this out to fix - PRODDEF-38249
        // if (buildProductState?.internet?.intlCalling?.selectedProduct !== '') {
        //   internationalCalling = <>
        //     <div className={ "margin-bottom-zero"} style={{margin:"16px 0px 20px 0px"}}>
        //       <div className="setupwaived tiny-p-70">
        //         <Body size={isMobile ? "small" : "medium"}>International calling-Standard</Body>
        //       </div>
        //       <span className={ "text-right includedRight right tiny-p-30 medium-p-25 totalDiscount-color" }>Included</span>
        //     </div>
        //   </>
        // }

        if (
          isCartDataEmpty &&
          cartState?.cartData[splitBillTab].listing !== undefined &&
          cartState?.cartData[splitBillTab].listing !== null &&
          cartState?.cartData[splitBillTab].listing.listingProds !== undefined &&
          cartState?.cartData[splitBillTab].listing.listingProds !== null &&
          cartState?.cartData[splitBillTab].listing.listingProds.length > 0
        ) {
          
          voiceEquipment = cartState?.cartData[splitBillTab].listing.listingProds.map((items, index) => {
         voiceSecTotalPrice = voiceSecTotalPrice + ( parseFloat(items?.price?.replace("$","")) || 0 )
            if(items.prodName?.toString()?.toLowerCase().includes('international calling') || window.location.href.indexOf("ordersummary") !== -1) {
                return <div className={ "margin-bottom-zero"} style={{margin:"16px 0px 20px 0px"}}>
              <div id="voice-selected" className="setupwaived tiny-p-70">
                <Body size={isMobile ? "small" : "medium"}>{items.prodName}</Body>
              </div>
              <span className={ `text-right includedRight right tiny-p-30 medium-p-25 ${(items.price === 'Included') ? 'totalDiscount-color' : ''}` }>
                {items.price === 'Included' ? items.price : items.price + '/mo'}
              </span>
            </div>
              
            } else if(items.prodName?.toString()?.toLowerCase().includes('fios digital voice')) { 
                return <div className={ "margin-bottom-zero"} style={{margin:"16px 0px 20px 0px"}}>
              <div id="voice-selected" className="setupwaived tiny-p-70">
                <Body size={isMobile ? "small" : "medium"}>{items.prodName}</Body>
              </div>
              <span className={ `text-right includedRight right tiny-p-30 medium-p-25 ${(items.price === 'Included') ? 'totalDiscount-color' : ''}` }>
                {items.price === 'Included' ? items.price : items.price + '/mo'}
              </span>
            </div>
              
            }
            return <div className={ "margin-bottom-zero"} style={{margin:"16px 0px 20px 0px"}}>
              <div id="voice-selected" className="setupwaived tiny-p-70">
                <Body size={isMobile ? "small" : "medium"}>{items.prodName}</Body>
              </div>
              <span className={ `text-right includedRight right tiny-p-30 medium-p-25 ${(items.price === 'Included') ? 'totalDiscount-color' : ''}` }>
                {items.price === 'Included' ? items.price : items.price + '/mo'}
              </span>
            </div>
          });
        }

        {/****Special gift offers****/}
       
        let voiceSpecialOffer = '';
        if (
        isCartDataEmpty &&
        cartState.cartData[splitBillTab].Promotions !== undefined &&
        cartState.cartData[splitBillTab].Promotions.promotions !== undefined &&
        cartState.cartData[splitBillTab].Promotions.promotions !== null &&
        cartState.cartData[splitBillTab].Promotions.promotions.length > 0
        ) {
          
          voiceSpecialOffer = cartState.cartData[splitBillTab].Promotions.promotions
          .filter((promoItems) => promoItems.offerFor === 'PHONE' || promoItems.offerFor === 'FIOS_VOICE')
          .map((promo, index) => {
            
            return <div className={ "margin-bottom-zero"} style={{margin:"16px 0px 20px 0px"}}>
              <Body>
                <div>
                  <span className="setupwaived tiny-p-70 medium-p-75 reviewOrderSavings">
                    {promo.promoText.includes('$')
                    ? promo.promoText
                    : promo.price && promo.price !== '0.00'
                    ? parseFloat(promo.price) === parseInt(promo.price)
                    ? promo.promoText
                    : promo.promoText
                    : promo.promoText}
                  </span>
                  <span className={ "text-right includedRight right tiny-p-30 medium-p-25 totalDiscount-color" }>Included</span>
                </div>
              </Body>
              </div>
            });
        } 

        {/**Inside wire Mantainance */}
        let monthlyCharge ='';
        if (cartState.cartData !== null && cartState.cartData.length > 0 && cartState.cartData[splitBillTab].internet !== null && cartState.cartData[splitBillTab].internet.internetProds !== undefined && cartState.cartData[splitBillTab].internet.internetProds !== null && cartState.cartData[splitBillTab].internet.internetProds.length > 0) {         
          monthlyCharge = cartState.cartData[splitBillTab].internet.internetProds.map((internet, index) => { 
            return <div className={ "margin-bottom-zero"} style={{margin:"16px 0px 20px 0px"}}>
            <div className="setupwaived tiny-p-70">
              <Body size={isMobile ? "small" : "medium"}>{internet.prodName}</Body>
            </div>
            <span className={ "text-right includedRight right tiny-p-30 medium-p-25" }>{internet?.price === 'Included' ? internet?.price : internet?.price + '/mo'}</span>
          </div>
        });
        }

        return (
          <>
            <div className={(voiceEquipment?.length || voiceSpecialOffer?.length || internationalCalling.length || monthlyCharge.length) ? 'cart-tabs' : 'hide'}>                
              <div>{internationalCalling}</div>
              <div>{displayNewNum}</div>
              <div>{voiceEquipment}</div>
              <div>{monthlyCharge}</div>
            </div>
          </>
        );
    }
    
    const togglePerks = () => {
      dispatch({ type: 'TOGGLE_INTERNET_ORDERPERKS_ACCOR', value: true });
      linkEditTagCall('add perks');      
    }
      
    const onCartSplitBillClick = (action) => {
        cartActions.splitBillTab(action, dispatch);
        setactiveTabIndex(action);
    }
   
    let tierData = '';
    const getClassicalHeader = () => {

      if (
        cartState.cartHeader !== undefined &&
        cartState.cartHeader !== null && 
        cartState.cartHeader.length > 0
      ) {
        if((
          lqState.isFCPflow || (
            lqState &&
            lqState.hoaFlowDetails &&
            lqState.hoaFlowDetails.isHoaFlow
          )
        )) {

          tierData="";

        } else {
          
          tierData = cartState.cartHeader.map((cartHeader, index) => {

            if(index===3){
              return null;
            }

            return <li className={splitBillTab === index ? "stepperClassicNC activeClassicNC" : "stepperClassicNC inactiveClassicNC"} cartindex={index} aria-selected="false" 
              onClick={(e) => onCartSplitBillClick(index)} key={index}>
              <div tabIndex="0" role="tab" aria-selected={splitBillTab === index } onKeyDown={(e) => this.handleTabKeyDown(e, index)}>
                <div id="Price" className="stepperPrice">{cartHeader.totalPrice === "0" ? tierprice : cartHeader.totalPrice}</div>
                <span id="MonthDesc" className="normal-weight text-small currentPlanTxt" >{ cartHeader.title}</span>
              </div>
            </li>
        })
        }
      }
      return tierData;
    }

    const ContentServiceRenderComp = (props) => {

      let showMainContent= true;
      if(props?.classicFlowType && props?.id!=='Internet'){
        showMainContent = false;
      }
      
      
      return (
      <React.Fragment>
        <div className={props?.mainTitle && !props?.classicFlowType ? (isMobile ? 'bg-white-border-mobile' : 'bg-white-border') : 'paddingClassicNC '}> 
         {showMainContent && <div className={isMobile ? "miniCartTitle" : `align_middle miniCartTitle ${isVoiceSelected ? 'tileMainTitleMini' : ''}`}>
         {
         props?.classicFlowType ? 
         <div className="width_100" style={{display:'flex'}}>
          <div style={{ width:'60%'}}><Title size="small" color="#6E6B65" primitive='h3' aria-hidden='true'>{props?.mainTitle}</Title></div>
          <div style={{color:"#6E6B65", width:'40%', textAlign:'right'}}><Title size="small" primitive='h3' aria-hidden='true' >{props?.price}</Title></div>
         </div>
         :  <ListGroup topLine={false} bottomLine={false} surface="light">
              <ListGroupItem actionElement={props?.classicFlowType ? 'textlink' :"none"} textLink={{
      text: props?.classicFlowType ? props?.price : '',
    }}>
              {(!isMobile && props?.img) && <ListGroupItemImage size="72" src={props?.img} />}
              <ListGroupItemTitle children={<Title size="small" color="#6E6B65">{props?.mainTitle}</Title>} />
              </ListGroupItem>
            </ListGroup>
          }
          
          </div>}
          { <hr aria-hidden="true" className = {`hrLineMini ${isMobile ? 'tileSubTitleMini' : ''}`} />}
          <div className="tileSubContentMini">
            <div className="width_100">
              {props?.mainHeaderSection}
            </div>
            <div className="width_100">
              {props?.listItems}    
            </div>
          </div>
        </div>
      </React.Fragment>
      );
    }

    // useEffect(() => {
    //   //dispatch({ type: 'TOGGLE_INTERNET_ORDERPERKS_ACCOR', value: false}); 
    // }, [])
    
      let internetImage = "https://ss7.vzw.com/is/image/VerizonWireless/fios-cr1000b-m-07122024?$pngalpha$&scl=1";
      let tvImage = isStreamServiceSelected ? "https://ss7.vzw.com/is/image/VerizonWireless/fios-youtube-m-07162024?$pngalpha$&scl=1" : "https://ss7.vzw.com/is/image/VerizonWireless/fios-tvsettopbox-m-07122024?$pngalpha$&scl=1";

    return (
    <React.Fragment>
      <div className="">
        <div className={"orderSubmitPadding"}>
          {isClassicalFlow ?
          <ul className = "w_tabs w_tabs_reskin m_cart-view m_equal-width scroll-shadow tileContent123" data-tabs="" data-xscroll="" aria-hidden="false" role="tablist" style={{position:isMobile?'relative':''}}>
            {getClassicalHeader()}
          </ul> : ''}
          <div className = {(isClassicalFlow && (classicDoublePlay || classicTriplePlay)) ? 'bg-white-border' : ''}>
          { isInternetSelected && 
            <ContentServiceRenderComp
              mainTitle={(isClassicalFlow && (classicDoublePlay || classicTriplePlay)) ? classicalTitle : 'Internet & perks'}
              mainHeaderSection={getInternetServiceHeader()}
              splitBillTab={splitBillTab} 
              listItems = {getInternetSubList()}
              showCaretIcon="true"              
              horizontalLine = "true"
              id="Internet"
              priceColor="green"  
              price={(isClassicalFlow && (classicDoublePlay || classicTriplePlay)) ? `${classicalPrice}/mo` : `$${internetSecTotalPrice?.toFixed(2)}/mo`}  
              img={(isClassicalFlow && (classicDoublePlay || classicTriplePlay)) ? '' : internetImage} 
              classicFlowType={(isClassicalFlow && (classicDoublePlay || classicTriplePlay))}
              />}
            
          { isTVSelected && 
            <ContentServiceRenderComp
              mainTitle={(isClassicalFlow && (classicDoublePlay || classicTriplePlay)) ? '' : 'Live TV'}
              mainHeaderSection={getTVServiceHeader()}
              splitBillTab={splitBillTab} 
              listItems = {getTVSubList()}
              showCaretIcon="true"   
              horizontalLine = {(isClassicalFlow && (classicDoublePlay || classicTriplePlay)) ? "false" : "true"}
              id="Tv"
              priceColor="green"   
              price={(isClassicalFlow && (classicDoublePlay || classicTriplePlay)) ? '' : `$${tvSecTotalPrice?.toFixed(2)}/mo` } 
              img={(isClassicalFlow && (classicDoublePlay || classicTriplePlay)) ? "" :tvImage} 
              classicFlowType={(isClassicalFlow && (classicDoublePlay || classicTriplePlay))}  
              />}
              
          { isVoiceSelected &&
            <ContentServiceRenderComp
              mainTitle={(isClassicalFlow && (classicDoublePlay || classicTriplePlay)) ? '' : 'Home phone'}
              mainHeaderSection={getVoiceServiceHeader()}   
              splitBillTab={splitBillTab} 
              listItems = {getVoiceSubList()}
              showCaretIcon="true"     
              horizontalLine = {(isClassicalFlow && (classicDoublePlay || classicTriplePlay)) ? "false" : "true"}
              id="Voice"
              priceColor="green"  
              price={(isClassicalFlow && (classicDoublePlay || classicTriplePlay)) ? '' : `$${voiceSecTotalPrice?.toFixed(2)}/mo`} 
              img={""}  
              classicFlowType={(isClassicalFlow && (classicDoublePlay || classicTriplePlay))}
              />} 
          </div> 
        </div>
      </div>
    </React.Fragment>);
  }

const mapStateToProps = state => {
    return {
      lqState: state.loopQual,      
      cartRedState: state.cart,  
      cartProfileState: state.profileCart,       
      buildProductState: state.buildProduct,  
      saveState:state.save,  
      moveExpState: state.moveExp.moveLandingExp,        
      visitId: state.app.visitId, 
      movesCustOpt: state.moveExp.cust_opt          
    }
  }

  export default React.memo(connect(mapStateToProps)(ReviewOrderReskin));
